import React, { useEffect, useRef, useState } from "react";
import { AppModel } from "../models";
import { DispatchContext } from "../store";
import { ReflexContainer, ReflexElement, ReflexSplitter } from "react-reflex";
import { getPreviewContent } from "../services/previewService";
import { StaticToolbar } from "./basic/Toolbar";
import { HtmlCodePanel } from "./HtmlCodePanel";
import { JsCodePanel } from "./JsCodePanel";
import { PreviewPanel } from "./PreviewPanel";
import config from "../config";
import "react-reflex/styles.css";

interface SiteDefaultViewProps {
  state: AppModel;
  versions: string;
  isJsSaved: boolean;
}

export const SiteDefaultView = ({
  state,
  versions,
  isJsSaved,
}: SiteDefaultViewProps) => {
  const { dispatch } = React.useContext(DispatchContext);
  const [jsCollapse, setjsCollapse] = useState(false);
  const [sizes, setSizes] = useState<{[key:string]: number | undefined}>({
    html: undefined,
    js: undefined
  });
  const [htmlCollapse, setHtmlCollapse] = useState(false);
  const [defaultSize, setDefaultSize] = useState<undefined | number>(undefined);
  const jsRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (jsRef.current) {
      setDefaultSize(jsRef.current.clientHeight);
    }
  }, [jsRef.current]);

  function toggleJs() {
    setTimeout
    setSizes({...sizes, js:  jsCollapse ? defaultSize : 43});
    setjsCollapse(!jsCollapse)
  }

  function toggleHtml() {
    setSizes({...sizes, html:  htmlCollapse ? defaultSize : 43});
    setHtmlCollapse(!htmlCollapse)
  }

  function resizeJs({ domElement }: any) {
    const el = domElement as HTMLDivElement;
    dispatch({
      type: "JsPanelResized",
      size: { height: el.clientHeight, width: el.clientWidth },
    })

  }

  function resizeHTML({ domElement }: any) {
    const el = domElement as HTMLDivElement;
    dispatch({
      type: "HtmlPanelResized",
      size: { height: el.clientHeight, width: el.clientWidth },
    })

  }

  return (
    <ReflexContainer orientation="vertical">
      <ReflexElement
        onStopResize={({ domElement }) => {
          const el = domElement as HTMLDivElement;
          if (state.htmlPanelSize) {
            dispatch({
              type: "HtmlPanelResized",
              size: {
                height: state.htmlPanelSize.height,
                width: el.clientWidth,
              },
            });
          }
          if (state.jsPanelSize) {
            dispatch({
              type: "JsPanelResized",
              size: { height: state.jsPanelSize.height, width: el.clientWidth },
            });
          }
        }}
      >
        <ReflexContainer>
          <ReflexElement
            className="st-code-pane"
            size={sizes.js}
            minSize={45}
            onStopResize={resizeJs}
            onResize={resizeJs}
          >
            <div ref={jsRef} style={{ height: "100%" }}>
              <JsCodePanel
                collapsable={true}
                collapse={!jsCollapse}
                codeValue={state.snippet.jsCode}
                toolbarClick={toggleJs}
                onChange={(value) =>
                  dispatch({
                    type: "JsCodeChanged",
                    code: value,
                  })
                }
                jsSettings={state.snippet.jsSettings}
                jsSettingsFormVisible={state.jsSettingsFormVisible}
                size={state.jsPanelSize}
                errorLine={state.scriptErrorLine}
                isSaved={isJsSaved}
                currentLibName={versions}
                isDarkMode={state.darkTheme}
              />
            </div>
          </ReflexElement>
          <ReflexSplitter style={{ display: "flex" }}>
            <div style={{ height: "15px", width: "100%", flexShrink: 0 }}></div>{" "}
          </ReflexSplitter>
          <ReflexElement
            className="st-code-pane"
            size={sizes.html}
            minSize={45}
            direction={-1}
            onStopResize={resizeHTML}
            onResize={resizeHTML}
          >
            <HtmlCodePanel
              collapsable={true}
              collapse={!htmlCollapse}
              toolbarClick={toggleHtml}
              codeValue={state.snippet.htmlCode}
              onChange={(value) =>
                dispatch({
                  type: "HtmlCodeChanged",
                  code: value,
                })
              }
              size={state.htmlPanelSize}
              isSaved={state.snippet.htmlCode === state.savedSnippet.htmlCode}
              isDarkMode={state.darkTheme}
            />
          </ReflexElement>
        </ReflexContainer>
      </ReflexElement>
      <ReflexSplitter style={{ display: "flex" }}>
        <div style={{ width: "15px", flexShrink: 0 }}></div>{" "}
      </ReflexSplitter>
      <ReflexElement>
        <div className="st-preview-pane">
          <div>
            <div className="st-code-pane--toolbar">
              <StaticToolbar controls={[{ type: "title", value: "Preview" }]} />
            </div>
          </div>
          <PreviewPanel
            iframeSrc={`${config.secureDomain}/snippet.html?${config.version}`}
            content={getPreviewContent(state.snippet)}
            cooling={state.previewCooling}
            previewInitialized={state.previewInitialized}
          />
        </div>
      </ReflexElement>
    </ReflexContainer>
  );
};
